import styled from 'styled-components';

import logo from '../../../../assets/img/sheep-orange.jpeg';
import background from '../../../../assets/img/girl.gif';

export const Container = styled.section`
  &.plan-offers {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1em;

    padding: 8em 15px;

    background: url(${background}) center;
    background-size: cover;
    /* background-repeat: space; */

    .plan-offers__title {
      color: white;

      font-family: 'Montserrat', sans-serif;
      font-size: 3.5rem;
      font-weight: bold;

      text-align: center;

      b {
        color: var(--green24);
      }
    }

    .plan-offers__call-to-action {
      color: white;

      font-family: 'Montserrat', sans-serif;
      font-size: 2rem;
      font-weight: 500;

      text-align: center;

      margin-top: -1.5rem;
    }

    .plan-offers__cards-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      gap: 1em;

      padding: 2em 0;
    }

    .plan-offers__plan-card {
      display: flex;
      flex-direction: column;

      width: 300px;
      height: 394px;

      color: #131e23;

      background-color: #fff;

      border-radius: 20px;
      box-shadow: 0 3px 6px rgb(0 0 0/16%);

      transform: scale(0.8);
    }

    .plan-offers__plan-card--yearly {
      position: relative;
      color: var(--green2c);

      transform: unset;
    }

    .plan-offers__price {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      width: 100%;
      height: 70%;

      padding: 0 0.375em;

      color: #131e23;
      font-size: 2.3rem;
      font-weight: bold;

      border-radius: 20px 20px 0 0;
      background: #f9ede4;
    }

    .plan-offers__price-value {
      /* display: inline-flex;
      flex-direction: column;
      justify-content: center;

      text-align: right;
      line-height: 2.1rem;
      margin-top: 20px; */

      font-size: 1.75rem;
      margin-bottom: 10px;
    }

    .plan-offers__price--yearly {
      background: linear-gradient(to bottom, var(--green2c) 60%, #1b8589 120%);
    }

    .plan-offers__small {
      position: relative;
      top: 2px;
      right: 2px;

      width: 90%;

      color: #131e23;
      font-size: 1.3rem;
      font-weight: 600;
      text-align: end;
      // letter-spacing: 1px;

      margin-left: auto;
    }

    .plan-offers__price-tag {
      width: 90px;
      height: 80px;

      margin-bottom: 15px;

      border-radius: 0 0 16px 16px;

      background: no-repeat center;
      background-size: 44px;
      background-color: #fff;
      background-image: url(${logo});
    }

    .plan-offers__plan-name {
      display: inline-flex;
      flex-direction: column;

      margin-top: 1.5rem;

      font-size: 2.5rem;
      font-family: 'Montserrat', sans-serif;
      font-weight: 700;
      text-align: center;
      line-height: 1.5rem;

      small {
        font-size: 1.5rem;
        font-family: 'Montserrat';
        font-weight: 500;
        text-transform: uppercase;
        letter-spacing: 2px;

        margin-bottom: 0.5rem;
      }
    }

    .plan-offers__benefit-container {
      margin-top: 10px;

      display: flex;
      flex-direction: column;
      gap: 0.625rem;

      @media (max-width: 1200px) {
        justify-content: center;
      }

      @media (max-width: 640px) {
        margin: 0px;
        flex-direction: column;
        align-items: center;
      }
    }

    .plan-offers__benefit {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      > p {
        width: 85%;
        font-family: 'Montserrat';
        font-size: 1.125rem;
        color: var(--green24);
        margin: 0;
        line-height: 1.375;
        text-align: left;
      }

      svg {
        width: 36px;
        height: 36px;
      }

      @media (max-width: 640px) {
        margin: 10px 0px;
      }
    }

    .plan-offers__advantage-tag {
      position: absolute;
      top: 40%;
      right: -90px;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      width: 17vw;
      height: 17vw;

      min-width: 110px;
      min-height: 110px;

      max-width: 155px;
      max-height: 155px;

      padding: 5px;

      color: #fff;
      font-size: clamp(0.8rem, 1.5vw, 1rem);
      font-weight: bold;
      text-align: center;
      text-transform: uppercase;
      line-height: 1.2rem;

      border: 1px solid #fff;

      border-radius: 60%;
      background-color: #f07554;

      transform: rotate(20deg);

      box-shadow: 0 0px 0px 4px #f07554, 0 3px 20px rgb(0 0 0/70%);

      small {
        margin-top: 5px;
        font-size: 0.6rem;
      }

      @media (max-width: 800px) {
        top: -10%;
        right: 0;
      }
    }

    .plan-offers__paragraph {
      width: 100%;
      max-width: 650px;

      color: var(--dark70);
      font-size: 1.25rem;
      text-align: center;

      b {
        color: var(--purpleA1);
        font-weight: bold;
        text-transform: uppercase;
      }
    }

    .plan-offers__invite {
      color: var(--green24);
      font-size: 5rem;
      font-family: 'Montserrat';
    }

    .primary-anchor,
    .secondary-anchor {
      max-width: 500px !important;
      height: 5rem;

      font-family: 'Montserrat', sans-serif;
      font-weight: bold;
      font-size: 1.75rem;

      color: #f9ede4;

      border-radius: 2.5rem;

      background: #e84e22;
    }
  }
`;
